import React, { useState, useEffect } from 'react';
import LeveledAntStats from './AntStatsLeveled.js';
import PremiumAnt from './images/ANT.png'; // Default image for premium ants
import BackButton from './BackButton';
import diamond from './images/Diamond.png';
import StakeDiamond from './images/Icon_Diamond.png';
import StatsInitialimg from './images/Icon_Initial.png';
import StatsTimespentimg from './images/Icon_Time.png';
import StatsEarnedimg from './images/Icon_Earned.png';
import StatsTotalimg from './images/Icon_Total.png';
import Slider from 'react-slick';
import { toast } from 'react-hot-toast';
import Tooltip from './Tooltip.js';
import useSolanaWeb3 from '../hooks/useSolanaWeb3.js'; 
import { useSelector } from 'react-redux';
import { selectAppLeveledNft } from '../store/appSlice.js';
import useFetchNfts from '../hooks/useFetchNfts.js';

function LevelingUnAssign({ goBack }) {
  const { handleUnLevelingGroundStake, fetchAllBalances } = useSolanaWeb3(); // Destructure your Solana web3 hook to get the unleveling function
  const { fetchLeveledNfts } = useFetchNfts()
  const [selectedANTItem, setSelectedAntItem] = useState(null);
  const [loading, setLoading] = useState(false);
  const [selectedNftIndex, setSelectedNftIndex] = useState(0);
  const { nfts: leveledNfts } = useSelector(selectAppLeveledNft)
  const [activeItem, setActiveItem] = useState(null);

  useEffect(() => {
    const loadNfts = async () => {
      console.log("Fetching leveled NFTs...");
      await fetchLeveledNfts();
      console.log("Leveled NFTs fetched:", leveledNfts);
    };

    loadNfts();
  }, []);

  const handleSelectButtonClick = () => {
    console.log("Selected ANT:", selectedANTItem); // Check if this logs the correct ANT
  };

  const handleANTItemClick = (ant) => {
    console.log("Ant clicked:", ant);
    setSelectedAntItem(ant);
    setActiveItem(ant.mint); // Store the unique identifier for the Ant
};

  const formatMint = (mint) => {
    if (!mint) return '';
    return `${mint.substring(0, 10)}...${mint.substring(mint.length - 10)}`;
  };

  const copyToClipboard = (text) => {
    if (!text) return;
    navigator.clipboard.writeText(text).then(() => {
      alert('Address copied to clipboard!');
    }, (err) => {
      console.error('Failed to copy address', err);
    });
  };

  const handleUnLevel = async (nftAddress) => {
      setLoading(true);
      try {
          await handleUnLevelingGroundStake(nftAddress); // Attempt to unlevel the NFT
          await fetchAllBalances()
          await fetchLeveledNfts(5)
          // selectedNftIndex(0)
          toast.success("NFT has been successfully unleveled"); // Success toast message
      } catch (error) {
          console.error("Error during unleveling process:", error); // Log error
          toast.error("Failed to unlevel NFT"); // Error toast message
      } finally {
          setLoading(false); // End loading action
      }
  };

  const calculateEXPEarned = (ant) => {
    if (!ant || ant.level === undefined || !ant.hoursPassed) {
      console.log("Invalid ANT data for EXP calculation:", ant);
      return 0;
    }
    const expEarned = ant.hoursPassed / (48.5 - ant.level);
    console.log(`EXP Earned for ANT ${ant.mint}:`, expEarned);
    return expEarned;
  };

  const getProgressPercentage = () => {
    if (selectedANTItem && selectedANTItem.remainPotions !== undefined && selectedANTItem.level !== undefined) {
      return (selectedANTItem.remainPotions / (selectedANTItem.level + 1)) * 100;
    }
    return 0;  // Default to 0 if data is not sufficient
  };

  const progressPercentage = getProgressPercentage();

  const selectedNft = leveledNfts[selectedNftIndex];
  console.log(leveledNfts);
  const expEarned = calculateEXPEarned(selectedNft);

  return (
    <section id="nestwars-ants">
      <div className="newui-container">
        <div className="platform-container">
          <div className="inventory-container">
            <div className="inventory-container-left">
            <BackButton goBack={goBack} title={"BACK TO LEVELING"} />
              <div className="inventory-items">
                {leveledNfts.map((nft, index) => {
                  const isPremium = nft.type;

                  return (
                    <div
                      key={index}
                      className={`inventory-item ${isPremium ? "item-premium" : "item-basic"} ${activeItem === nft.mint ? "active9" : ""}`} // Highlight active Ant
                      onClick={() => handleANTItemClick(nft)}
                    >
                      <img src={nft.image} alt="" />
                      <div className="inventory-item-texts">
                        <p className="inventory-text">{nft.name}</p>
                        <p className="inventory-level-text">LVL:</p>
                        <p className="inventory-text">{nft.level}</p>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
            <div className="inventory-container-right">
            {selectedANTItem ? (
                <>
                  <div className="active-item-header-content-activity" id="ant-header-activity">
                    <div className="inventory-item-active-activity antonright-activity" id="ant-header-activity3"><img src={selectedANTItem.metadata?.image || PremiumAnt} alt={selectedANTItem.name}/></div>
                    <div className="active-item-header-activity">
                      <h2>WORKER ANT</h2>
                      <p>{selectedANTItem.nftType ? "Premium ant" : "Basic ant"}</p>
                      <p id="w-address" style={{ cursor: 'pointer' }} onClick={() => copyToClipboard(selectedANTItem.mint)}>{formatMint(selectedANTItem.mint)}</p>
                    </div>
                  </div>
                  <div className="level-bar-container" id="level-bar-leveling">
                  <div className="level-bar">
                    <div className="level-indicator">
                    LVL: <span className="bold-text">{selectedANTItem.level}</span>
                    </div>
                    <div className="exp-bar-container">
                      <div 
                        className="exp-bar" 
                        style={{ width: `${progressPercentage}%` }}
                      ></div>
                    </div>
                    <div className="exp-info">
                      EXP:<span className="bold-text"> {selectedANTItem.remainPotions}/{selectedANTItem.level+1}</span>
                    </div>
                  </div>
                  </div>
                  <div className="active-item-ant-container-activity3" id="stats-activity-container-unassign">
                    <div className="active-item-stats-activity-2" id="stats-activity-unassign"><p>INITIAL EXP</p><h2>{leveledNfts[selectedNftIndex]?.remainPotions}</h2></div>
                    <div className="active-item-stats-activity-2" id="stats-activity-unassign"><p>TIME SPENT</p><h2>{leveledNfts[selectedNftIndex]?.levelGroundUpdatedTimeString}</h2></div>
                    <div className="active-item-stats-activity-2" id="stats-activity-unassign"><p>EXP EARNED</p><h2>{Math.floor(expEarned)}</h2></div>
                    <div className="active-item-stats-activity-2" id="stats-activity-unassign"><p>TOTAL</p><h2>{Math.floor((leveledNfts[selectedNftIndex]?.remainPotions || 0) + expEarned)}</h2></div>
                  </div>
              <div className="active-item-buttons-container-activity">
            <button className="active-item-button-lower" id="basic-ant-button-assign" onClick={() => handleUnLevel(leveledNfts[selectedNftIndex]?.address)}>
              <span>{loading ? "Loading..." : "REDEEM ANT"}</span>
            </button>
            </div>
                </>
              ) : (
                <h2 className="inventory-info-text">Choose an ANT to get more info</h2>
              )}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default LevelingUnAssign;